export default {
  body: {
    cmpt: {
      type: 'CTdlDeviceDetail'
    }
  }
}
